/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { DatalistAnagrafica, Monitoraggio } from '@models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { UtilsService } from '@shared/services/utils.service';
import { ToolkitGestioneOperaModalMonitoraggioComponent } from '../modal-monitoraggio/modal-monitoraggio.component';

@Component({
    selector: 'app-toolkit-opera-tab-monitoraggio',
    templateUrl: './tab-monitoraggio.component.html',
})
export class ToolkitGestioneOperaTabMonitoraggioComponent implements OnInit{

    @Input() canEdit: boolean;
    @Input() items: Monitoraggio[] = [];
    @Input() datalist: DatalistAnagrafica;

    constructor(
        private modalService: NgbModal,
        private operaService: OperaService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.operaService.monitoraggioByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: Monitoraggio[]) => {
            this.items = list;
        });      
    }
    public viewItem(monitoraggio: Monitoraggio) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalMonitoraggioComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Aggiungi';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = monitoraggio;
        modal.componentInstance.canEdit = false;
    }
    
    public addItem() {
        const modal = this.modalService.open(ToolkitGestioneOperaModalMonitoraggioComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Aggiungi';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.canEdit = true;
        modal.result.then(result => {
            if (result) {
                this.operaService.insertMonitoraggio(result.getRawValue()).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.operaService.monitoraggioByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: Monitoraggio[]) => {
                        this.items = list;
                    });
                });
            }
        }).catch(e => {});
    }

    public editItem(monitoraggio: Monitoraggio) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalMonitoraggioComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Modifica';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = monitoraggio;
        modal.componentInstance.canEdit = true;
        modal.result.then(result => {
            if (result) {
                this.operaService.updateMonitoraggio(result.getRawValue()).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.operaService.monitoraggioByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: Monitoraggio[]) => {
                        this.items = list;
                    });
                });
            }
        }).catch(e => {});
    }

    public deleteItem(idMonitoraggio: number) {
        this.operaService.deleteMonitoraggio(idMonitoraggio).subscribe(response => {
            if (this.utilsService.genericResponse204NoContent(response)) {
                this.operaService.monitoraggioByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: Monitoraggio[]) => {
                    this.items = list;
                });
            }
        });
    }

}
